export default "__VITE_ASSET__400b1c84__"